import { render, staticRenderFns } from "./service_provision.vue?vue&type=template&id=59933068&"
import script from "./service_provision.vue?vue&type=script&lang=js&"
export * from "./service_provision.vue?vue&type=script&lang=js&"
import style0 from "./service_provision.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports